(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-gift-picker"] && !Shopify.designMode) return;
  try {
    /* Feedback after a gift is picked: the page navigates (add, then back to the
     cart), which takes a moment, so lock the other Select buttons and turn the
     clicked one into "Updating…". Without it the shopper can click a second gift
     while the first request is in flight and end up with two gift lines. Delegated
     on `document` because the cart section is morphed and replaces the forms.
     Runs after the submit event (setTimeout 0) so the submission itself is never
     interfered with. */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.gift-picker-popover__card')) return;

    const popover = form.closest('.gift-picker-popover');
    const clicked = form.querySelector('.gift-picker-popover__select');
    if (!popover || !clicked) return;

    setTimeout(() => {
      popover.querySelectorAll('.gift-picker-popover__select').forEach((button) => {
        button.disabled = true;
      });
      clicked.setAttribute('aria-busy', 'true');
      if (!clicked.querySelector('.gift-picker-popover__spinner')) {
        const spinner = document.createElement('span');
        spinner.className = 'gift-picker-popover__spinner';
        spinner.setAttribute('aria-hidden', 'true');
        clicked.prepend(spinner);
      }
      const label = clicked.querySelector('.cta__label');
      if (label && popover.dataset.updatingLabel) label.textContent = popover.dataset.updatingLabel;
    }, 0);
  });

  /* Back/forward cache can restore the page with the buttons still locked. */
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && document.querySelector('.gift-picker-popover__select[aria-busy="true"]')) {
      window.location.reload();
    }
  });

  /* Browsers without the Popover API (Safari before 17): `popovertarget` does
     nothing there, so open and close by class instead; the matching styles sit in
     the `@supports not selector(:popover-open)` block of the stylesheet. */
  if (!('popover' in HTMLElement.prototype)) {
    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element && event.target.closest('[popovertarget]');
      if (!trigger) return;
      const target = document.getElementById(trigger.getAttribute('popovertarget'));
      if (!target || !target.classList.contains('gift-picker-popover')) return;
      const hide = trigger.getAttribute('popovertargetaction') === 'hide';
      target.classList.toggle('is-open', hide ? false : !target.classList.contains('is-open'));
    });
  }
  } catch(e) { console.error(e); }
})();

})();
